import { useEffect, useState } from 'react';
import { adminApi } from '@/services/api';
import { formatNumber } from '@/services/format';

export function DashboardPage() {
  const [stats, setStats] = useState<{ features: number; metrics: number; clients: number } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const [features, metrics, clients] = await Promise.all([
          adminApi.features(),
          adminApi.metrics(),
          adminApi.clients(1, 1),
        ]);
        setStats({ features: features.length, metrics: metrics.length, clients: clients.total });
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Não foi possível carregar o painel');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="p-8 max-w-[1280px] mx-auto">
      <h1 className="page-h1 mb-8">Painel</h1>
      {loading && <p className="text-gray-500">A carregar…</p>}
      {error && <p className="text-magni-red-600">{error}</p>}
      {stats && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Tile label="Funcionalidades" value={stats.features} />
          <Tile label="Métricas" value={stats.metrics} />
          <Tile label="Clientes com utilização" value={stats.clients} />
        </div>
      )}
    </div>
  );
}

function Tile({ label, value }: { label: string; value: number }) {
  return (
    <div className="card">
      <p className="eyebrow mb-2">{label}</p>
      <p className="text-3xl font-bold text-gray-900">{formatNumber(value)}</p>
    </div>
  );
}
